<template>
  <div class="regi">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">查看</p>
      <div></div>
    </div>
    <div class="cenbox">
      <div class="cenli">
        <span
          ><span class="color6">业务：</span>{{ from.bizName || "--" }}</span
        >
        <span
          ><span class="color6">船名：</span> {{ from.shipName || "--" }}</span
        >
      </div>
      <div class="cenli">
        <span
          ><span class="color6">船东：</span> {{ from.shipowner || "--" }}</span
        >
        <span
          ><span class="color6">电话：</span>
          {{ from.shipownerPhone || "--" }}</span
        >
      </div>
      <div class="describe">
        <span
          ><span class="color6">故障描述：</span> {{ from.hitch || "--" }}</span
        >
      </div>
      <div class="describe">
        <span class="flexsb"
          ><span class="color6">设备sn：</span> {{ from.sn || "--" }}</span
        >
      </div>
      <div class="describe">
        <span class="flexsb"
          ><span class="color6">维修方式：</span>
          {{
            from.type == 1 ? "维修设备" : from.type == 2 ? "更换设备" : "--"
          }}</span
        >
      </div>
      <div class="describe" v-if="this.from.type == 2">
        <span class="flexsb"
          ><span class="color6">新设备sn：</span>
          {{ from.freshSn || "--" }}</span
        >
      </div>
      <div class="describe">
        <span
          ><span class="color6">维修备注：</span>
          {{ from.remark || "--" }}</span
        >
      </div>
      <div class="describe">
        <div class="color6">维修照片：</div>
        <div class="imgli">
          <van-image
            class="imgss"
            v-for="item in this.from.imgs"
            :key="item.id"
            width="90"
            height="90"
            :src="item.img"
            @click="imginfo(item.img)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { repairgetInfo } from "@/utils/network/interface";
export default {
  name: "register",
  data() {
    return {
      from: {},
      id: this.$route.query.id,
    };
  },
  created() {
    this.repairgetInfoFr();
  },
  mounted() {},
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    repairgetInfoFr() {
      repairgetInfo({ id: this.id }).then((e) => {
        console.log(e, "详情");
        this.from = e.data;
      });
    },
    imginfo(url) {
      ImagePreview([url]);
    },
  },
};
</script>

<style lang="less" scoped>
.regi {
  .nav {
    display: flex;
    height: 60px;
    background-color: #3db0fc;
    align-items: center;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }
  .cenbox {
    width: 92%;
    background-color: #fff;
    height: calc(100vh - 180px);
    margin: 16px auto 0;
    border-radius: 6px;
    padding: 20px;
    font-size: 14px;
    color: #333;
    .color6 {
      color: #666;
    }
    .cenli {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
    }
    .describe {
      // border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
      line-height: 20px;
      .imgli {
        display: flex;
        // align-items: center;
        // justify-content: space-between;
        flex-wrap: wrap;
        .imgss {
         margin-right: 10px;
        }
      }
      .flexsb {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .vinpu {
      display: flex;
      align-items: center;
      .van-cell {
        padding: 6px 0;
      }
      .imgs {
        width: 20px;
        height: 20px;
      }
    }
  }
  .bottbx {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 40px;

    .type1 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: #c8c8c8;
      border: 1px solid #c8c8c8;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
      margin-right: 5px;
    }
    .type2 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: #3db0fc;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
      margin-right: 5px;
    }
  }
}
</style>